exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cnrsIv6FFS3PN0SYdxH_S {\n  cursor: move;\n}", ""]);
// Exports
exports.locals = {
	"handle": "cnrsIv6FFS3PN0SYdxH_S"
};